export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6503.ef7c9f74.jpg";